export const GET_AVAILABLE_EDOK_MODULES_SUCCESS = 'GET_AVAILABLE_EDOK_MODULES_SUCCESS';

export const getAvailableEdokModulesSuccess = ({ modules, moduleForms }) => ({
    type: GET_AVAILABLE_EDOK_MODULES_SUCCESS,
    payload: {
        modules,
        moduleForms,
    }
});
